var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-footer"},[_c('SdsIcon',{staticClass:"match-footer__icon",attrs:{"iconName":"status-info","size":"sm"}}),_c('span',{staticClass:"match-footer__text"},[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }